/* eslint-disable */
import {
  Badge,
  IconButton,
  ListItemIcon,
  MenuItem,
  Paper,
  Popper,
  Snackbar,
  SnackbarCloseReason,
} from '@mui/material';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { UserService } from '../../services/user/user.service';
import styles from './notifications.module.scss';
import { useNotificationData } from '../../contexts/notification-data.context';
import { notificationBellPreview } from '../badges/special-number-display';

interface Props {
  iconColor?: string;
}

function Notifications(props: Props): JSX.Element {
  const history = useHistory();
  const { count: notificationsCount, setCount: setNotificationsCount } =
    useNotificationData();

  const [notifications, setNotifications] = React.useState<any>([]);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const openPanel = Boolean(anchorEl);
  const MINUTE_MS = 60000;

  const handleCloseNotification = () => {
    setAnchorEl(null);
  };

  const handleClickNotification = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setAnchorEl((prev) => (prev ? null : event.currentTarget));
  };

  const handleCloseNotificationMenuItem = (event: any) => {
    const { myValue } = event.currentTarget.dataset;
    openNotification(myValue);
  };

  const openNotification = async (notificationId: string) => {
    try {
      await new UserService().readNotification(notificationId);
      fetchNotifications();
      fetchNotificationsCount();
    } catch (error) {
      console.error(error);
    }
    handleCloseNotification();
    history.push(
      `/u/notification?notification=${encodeURIComponent(notificationId)}`,
    );
  };
  const [open, setOpen] = React.useState(false);
  const [messageNotification, setMessageNotification] = React.useState('');

  const handleClose = (
    event?: React.SyntheticEvent | Event,
    reason?: SnackbarCloseReason,
  ) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };

  const fetchNotifications = async () => {
    try {
      const result = await new UserService().fetchNotifications();
      if (result?.length > 0) {
        const [firstNotification] = result;
        if (
          firstNotification?.metaData?.TYPE === 'USER_ONBOARDING_NOTIFICATION'
        ) {
          setMessageNotification(firstNotification.message);
          setOpen(true);
        }
      }
      setNotifications(result);
    } catch (error) {
      console.error('Error fetching notifications:', error);
    }
  };

  const fetchNotificationsCount = async () => {
    try {
      const result = await new UserService().fetchNotificationsCount();
      setNotificationsCount(result.count);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchNotifications();
    fetchNotificationsCount();
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      fetchNotifications();
      fetchNotificationsCount();
    }, MINUTE_MS);

    return () => clearInterval(interval);
  }, []);

  const { iconColor } = props;

  return (
    <>
      <Snackbar
        open={open}
        autoHideDuration={20000}
        onClose={handleClose}
        style={{
          background: 'var(--qc-shell-surface, #071426)',
          border: '1px solid',
          padding: '20px',
          borderRadius: '10px',
        }}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          <div
            style={{
              maxWidth: '350px',
            }}
          >
            {messageNotification}
          </div>
          <div
            style={{
              maxWidth: '350px',
              cursor: 'pointer',
            }}
            onClick={handleClose}
          >
            close
          </div>
        </div>
      </Snackbar>
      <Badge
        badgeContent={notificationsCount}
        color="secondary"
        className={styles.badgeClassStyles}
      >
        <IconButton
          aria-label="Notifications"
          id="long-button"
          aria-controls={openPanel ? 'notification-menu' : undefined}
          aria-expanded={openPanel ? 'true' : undefined}
          aria-haspopup="true"
          onClick={handleClickNotification}
          className={styles.iconButtonNotificationClass}
          size="large"
        >
          <span className="material-icons">notifications</span>
        </IconButton>
      </Badge>
      {openPanel && (
        <Popper
          id="notification-menu"
          open
          anchorEl={anchorEl}
          placement="bottom-end"
          className={styles.notificationPopper}
          modifiers={[
            {
              name: 'offset',
              options: {
                offset: [0, 10],
              },
            },
          ]}
        >
          <ClickAwayListener onClickAway={handleCloseNotification}>
            <Paper className={styles.notificationContainer} elevation={0}>
              {notifications.length === 0 ? (
                <div className={styles.emptyState}>
                  <span
                    className={`material-icons ${styles.iconMaterialDesign}`}
                  >
                    notifications_none
                  </span>
                  <span>No New Notifications</span>
                </div>
              ) : (
                notifications.map((option: any) => (
                  <MenuItem
                    key={option._id}
                    data-my-value={option._id}
                    className={`${styles.notificationItem} ${
                      option.isRead ? styles.isRead : styles.isUnread
                    }`}
                    onClick={handleCloseNotificationMenuItem}
                  >
                    <ListItemIcon className={styles.itemIcon}>
                      <span className="material-icons">
                        {option.isRead
                          ? 'mark_email_read'
                          : 'mark_email_unread'}
                      </span>
                    </ListItemIcon>
                    <p className={styles.notificationContent}>
                      {notificationBellPreview(option.message)}
                    </p>
                  </MenuItem>
                ))
              )}
            </Paper>
          </ClickAwayListener>
        </Popper>
      )}
    </>
  );
}

Notifications.defaultProps = {
  iconColor: 'white',
};

export default Notifications;
